import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconInvoice = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeMiterlimit: 10,
			d: "M9.5 10h5m-5 8h4m-4-4h4m-4 8h2M26.5 4l-3.05-3-2.95 2-3-2-3 2-3-2-3 2-3-2v27l3.05 3 2.95-2 3 2 3-2 3 2 3-2 3 2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeMiterlimit: 10,
			d: "M22.45 11.35A2.5 2.5 0 0 0 20 9.25c-1.4 0-2.5.9-2.5 2.3s1.25 2 2.5 2.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeMiterlimit: 10,
			d: "M17.5 16.25a2.5 2.5 0 0 0 2.5 2.5m0 0a2.6 2.6 0 0 0 2.5-2.6c0-1.4-1.25-2-2.5-2.3m0 4.9V20m0-10.75V8"
		})
	]
});
export default SvgIconInvoice;
